import { atom } from "recoil";

export const SelectedAssetPlaylistState = atom<string | null>({
  key: "selectedAssetPlaylistState",
  default: null,
});
